export default [
  {
    path: '/admin/system/console',
    name: 'SystemConsole',
    component: () => import('@/views/Admin/System/Console/Index.vue'),
    meta: {
      pageTitle: 'Konsol',
      breadcrumb: [
        { text: 'Sistem', active: false },
        { text: 'Konsol', active: true },
      ],
      resource: 'audit-logs.list',
      action: 'manage',
    },
  },
]
